import script from "./ProjectDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectDocuments.vue?vue&type=style&index=0&id=3c13611e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c13611e"]])

export default __exports__